import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environments';
import { endpoints } from '../endpoints';
import { IFunctionCourseOfActions, IFunctionGoals } from '../models/functionGoal';
import { ErrorService } from '../helpers/errorService';

@Injectable({
    providedIn: 'root'
})
export class CoursesOfActionService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getCourseOfAction(buildingId: string, function_or_threat: string): Observable<{has_error: boolean, message: string, data: any[]}> {
        const url = environment.apiBaseUrl + endpoints.getCourseOfAction.replace(':buildingId', buildingId).replace(':functionOrThreat', function_or_threat);
        return this.http.get<{has_error: boolean, message: string, data: any[]}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    saveCourseOfAction(buildingId: string, function_or_threat: string, function_threat_id: string, courseOfAction: IFunctionCourseOfActions): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.updateCourseOfAction.replace(':buildingId', buildingId).replace(':functionOrThreat', function_or_threat).replace(':funcionThreatId', function_threat_id);
        return this.http.post<{has_error: boolean, message: string, data: any}>(url, courseOfAction).pipe(
        catchError(this.errorService.handleError)
        );
    }
}